import { render, staticRenderFns } from "./DepartSelector.vue?vue&type=template&id=4a712d9d&scoped=true"
import script from "./DepartSelector.vue?vue&type=script&lang=js"
export * from "./DepartSelector.vue?vue&type=script&lang=js"
import style0 from "./DepartSelector.vue?vue&type=style&index=0&id=4a712d9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a712d9d",
  null
  
)

export default component.exports